const RightArea = () => {
  return <div style={{ backgroundColor: "white", width: "10%" }}></div>;
};

export default RightArea;
